<template>
  <div id="app" class="app-shell">
    <SiteHeader />
    <main class="app-main">
      <router-view />
    </main>
    <SiteFooter />
  </div>
</template>

<script setup>
import SiteFooter from '@/components/SiteFooter.vue'
import SiteHeader from '@/components/SiteHeader.vue'
</script>

<style lang="scss">
:root {
  --page-bg: #f3f7fc;
  --card-bg: #ffffff;
  --primary: #1158d6;
  --primary-dark: #0d3f99;
  --text-main: #183153;
  --text-secondary: #5f718c;
  --border-color: rgba(17, 88, 214, 0.12);
  --shadow-main: 0 18px 40px rgba(28, 60, 114, 0.12);
}

* {
  box-sizing: border-box;
}

html,
body,
#app {
  margin: 0;
  min-height: 100%;
  font-family: "Microsoft YaHei", "PingFang SC", "Hiragino Sans GB", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-main);
  background:
    radial-gradient(circle at top left, rgba(17, 88, 214, 0.16), transparent 28%),
    radial-gradient(circle at top right, rgba(22, 196, 127, 0.1), transparent 24%),
    var(--page-bg);
}

a {
  color: inherit;
  text-decoration: none;
}

.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-main {
  // width: min(1400px, calc(100% - 48px));
  // margin: 0 auto;
  flex: 1;
  // padding: 28px 0 40px;
}

@media (max-width: 768px) {
  .app-main {
    width: calc(100% - 24px);
    padding-top: 20px;
  }
}
</style>
